import { useEffect } from "react";
// utils
import { isObject } from "src/utils/format-object";

// ----------------------------------------------------------------------

export function useWaitForFcWidget(callback) {
    useEffect(() => {
        let isMounted = true;

        function checkFcWidget() {
            if (isObject(window.fcWidget)) {
                if (isMounted) {
                    callback(window.fcWidget);
                }
            } else {
                setTimeout(checkFcWidget, 300); // Retry every 300ms
            }
        }

        checkFcWidget();

        return () => {
            isMounted = false;
        };
    }, [callback]);
}
